export const manageTeamTooltips = {
  persona: `
    <p>Personas are typically associated with job title and captured during sign up.
      <a href="https://help.datapeople.io/article/233-user-settings">Read more here</a>
    </p>
  `,
  jobRole: `
    <p>Job Roles reflect permissions associated with individual jobs in an ATS.
      <a href="https://help.datapeople.io/article/233-user-settings">Read more here</a>
    </p>
  `,
  datapeoplePermissions: `
    <p>JobNav Recruiter Permissions set each person's role (Editor, Analytics Admin, Admin, or IT Admin). Admins can change org settings and see all public jobs. Analytics Admins can see all jobs in Insights, but cannot change those settings.
      <a href="https://help.datapeople.io/article/233-user-settings">Read more here</a>
    </p>
  `,
  jobNavPermissions: `
    <p>JobNav Permissions control the user's role within the Job Profile navigation module.
      <a href="https://help.datapeople.io/article/233-user-settings">Read more here</a>
    </p>
  `,
  datapeopleActions: `
  <p>You can send two types of onboarding emails to users:
    1. Onboarding them onto the JobNav platform
    2. Inviting them to install Datapeople Anywhere.
    <a href="https://help.datapeople.io/article/233-user-settings">Read more here.</a>
  </p>
  `,
};
